import { render, staticRenderFns } from "./BackIcon.vue?vue&type=template&id=1cf3a4d4&scoped=true"
var script = {}
import style0 from "./BackIcon.vue?vue&type=style&index=0&id=1cf3a4d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf3a4d4",
  null
  
)

export default component.exports